import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'templates'
const verb = HttpMethod.DELETE

export default class OspreyTemplatesUnshareArchive extends BaseAction {
    constructor(dataKey) {
        const id = '558621b8-9c6d-442c-8291-e6d3a2565777'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    unShareArchiveTemplate(params) {
        const { templateId, siloIdList, affiliationIdList } = params

        this.path = `/${resource}/${templateId}`

        this.params = {
            affiliationIdList,
            siloIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-unShare-archive.js